import axios from "axios";
import {ArticlePhotoshopData} from "./articleStoreApiTypes";

export async function getArticlePhotoshopData(m3Id: string): Promise<ArticlePhotoshopData> {
  const { data } = await axios.get<ArticlePhotoshopData>(`/api/article/${m3Id}/psinfo`);
  return data;
}
